<app-navbar></app-navbar>
<section>
  <div class="container">
    <div class="row">
      <div class='card m-5'>
        <div class='card-body'>
          <div class="col-md-12">
            <h1 class="custom-title mt-3">Assistant Patron's Message</h1>
            <div class="custom-image">
              <img src="assets/img/school/messages/2.jpg" alt="Image" class="img-fluid" style="max-width: 100%;">
            </div>
            <div class="custom-text mt-3">
              <p>"The father of a child sleeps in the heart of all children" This famous quote of the poet applies to
                all types of
                children. Every child is genetically born with certain characteristics. As his physical and mental
                development slows
                down with age, his parents become increasingly worried. Gradually, they turn out to be a child with
                special needs.
                Aiming to meet the special needs of special children and provide them with education like typical
                children with the
                target of achieving self-reliance, Proyash-Chattogram has emerged as a successful, noble, and worthwhile
                institution.
                This institution plays a leading role in the personal, physical, and mental development of special
                children as well as
                developing their special talents. My sincere love to all the teachers, therapists, and assistants of
                this institution
                whose tireless work, intensive care, and sincere cooperation are helping the special needs children to
                move forward.
                They really deserve praise. I feel blessed that Almighty Allah has given me the opportunity to do
                something for these
                children with special needs. I believe that Proyash-Chattogram will be able to be an institute of
                excellence. I wish
                Proyash-Chattogram continued success, prosperity, and progress. May Allah help us all, Ameen.</p>
              <p>Jai Bangla, May Bangladesh live forever.</p>
              <br>
              <br>
              <p class="custom-bold">Fatematuz Zohra</p>
              <p>Assistant Patron Proyash-Chattogram</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>